import { render } from "./weeklyRankRewardsCall.vue?vue&type=template&id=23386e3b"
import script from "./weeklyRankRewardsCall.vue?vue&type=script&lang=js"
export * from "./weeklyRankRewardsCall.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__